<template>
  <div class="page">
    <!--我要申请 => 预约二维码 -->
    <!-- <span>declaration</span> -->
    <van-nav-bar
      class="nav"
      title=""
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="pgt">
      <img
        v-if="banner.imagePath"
        class="pa-top"
        :src="banner.imagePath | qiniuImageView(1, 710, 314)"
        alt=""
      />
      <div class="info-box">
        <div class="title">填写资料</div>
        <div class="twonum">
          <div class="num1">
            <span class="num1-txt">配额数：</span>
            <span style="color: #fd4a46">{{ infodata.usableCount || 0 }}</span>
          </div>
          <div class="num2">
            <span class="num2-txt">已申报数：</span>
            <span style="color: #fd4a46">{{ infodata.usedCount || 0 }}</span>
          </div>
        </div>
        <div class="form-box" style="margin-top: 10px">
          <van-form>
            <div class="flex-box">
              <span class="label">申请单位</span>
              <van-field
                style="
                  border: 1px solid #ccc;
                  height: 40px;
                  border-radius: 10px;
                  line-height: 20px;
                "
                v-model="formData.applicantName"
                name="申请单位"
                placeholder="请输入申请单位"
                :rules="[{}]"
              >
              </van-field>
            </div>
            <div class="flex-box">
              <span class="label">预约日期</span>
              <van-field
                style="
                  border: 1px solid #ccc;
                  height: 40px;
                  border-radius: 10px;
                  line-height: 20px;
                "
                readonly
                clickable
                name="datetimePicker"
                :value="formData.date"
                placeholder="点击选择时间"
                @click="showPicker = true"
              />
              <van-popup v-model="showPicker" position="bottom">
                <van-datetime-picker
                  type="date"
                  @confirm="onConfirm"
                  @cancel="showPicker = false"
                  :min-date="minDate"
                  :max-date="maxDate"
                />
              </van-popup>
            </div>
            <div class="flex-box">
              <span class="label">预约人数</span>
              <van-field
                style="
                  border: 1px solid #ccc;
                  height: 40px;
                  border-radius: 10px;
                  line-height: 20px;
                "
                v-model="formData.population"
                name="预约人数"
                placeholder="请输入人数"
                :rules="[{}]"
                type="digit"
              >
              </van-field>
            </div>
            <div class="flex-box">
              <span class="label">领队姓名</span>
              <van-field
                style="
                  border: 1px solid #ccc;
                  height: 40px;
                  border-radius: 10px;
                  line-height: 20px;
                "
                v-model="formData.realname"
                name="领队姓名"
                placeholder="请输入姓名"
                :rules="[{}]"
              >
              </van-field>
            </div>
            <div class="flex-box">
              <span class="label">手机号</span>
              <van-field
                style="
                  border: 1px solid #ccc;
                  height: 40px;
                  border-radius: 10px;
                  line-height: 20px;
                "
                v-model="formData.phone"
                name="手机号"
                type="tel"
                placeholder="请输入手机号"
                maxlength="11"
                @input="okPhone"
                @blur="okPhone"
              >
              </van-field>
            </div>

            <div class="flex-box-tip" v-show="redPhone">请输入正确的手机号</div>

            <div class="license">
              <div class="label">上传图片</div>
              <div class="tip">
                <span class="tip-txt">请上传图片</span>
              </div>
              <van-field name="uploader" :rules="[{ message: '上传图片' }]">
                <template #input>
                  <van-uploader
                    name="uploader"
                    :max-count="3"
                    :after-read="afterRead"
                    :before-delete="afterDelete"
                    :before-read="beforeRead"
                    :disabled="noCanUp"
                  >
                    <div class="img-list">
                      <div v-show="formData.imgs.length > 0">
                        <div
                          class="img-box"
                          v-for="(image, index) in formData.imgs"
                          :key="index"
                        >
                          <img :src="image | qiniuImageView(1, 140, 140)" />
                          <div class="img-box-d" @click="afterDelete(index)">
                            x
                          </div>
                        </div>
                      </div>
                      <img
                        style="margin-left: 20px"
                        v-show="formData.imgs.length < 3"
                        width="70"
                        height="70"
                        src="../../assets/images/pa-ex.png"
                        alt=""
                        srcset=""
                      />
                    </div>
                    <!-- <template #preview-cover="{ file }" >
                    <div class="preview-cover van-ellipsis">
                      {{ file.name }}
                    </div>
                  </template> -->
                  </van-uploader>
                </template>

                <!-- 使用组件渲染，需要base64 -->
                <!-- <template #input> 
                <van-uploader name="uploader" v-model="formData.license" :max-count="3" :after-read="afterRead" :before-delete="afterDelete" :before-read="beforeRead">
                  <img width="70" height="70" src="../../assets/images/pa-ex.png" alt="" srcset="" />
                  <template #preview-cover="{ file }">
                    <div class="preview-cover van-ellipsis">
                      {{ file.name }}
                    </div>
                  </template>
                </van-uploader>
              </template> -->
              </van-field>
            </div>

            <div class="gou">
              <div
                class="label"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                购买接驳车车票
              </div>
              <van-checkbox
                v-model="ismai"
                checked-color="#ee0a24"
                @change="changemai"
              ></van-checkbox>
            </div>

            <div style="margin: 16px">
              <Button
                round
                block
                type="info"
                native-type="submit"
                style="background-color: #fd4a46; border: none"
                @click="onSubmit"
                >立即提交</Button
              >
            </div>
            <div class="xxxxx"></div>
          </van-form>
        </div>
        <div class="bottom-tip" v-show="false">
          提示：不好意思，当天预约次数已满！
        </div>
      </div>
      <div class="empt"></div>
    </div>

    <van-tabbar v-model="active" style="position: fixed; bottom: 0">
      <van-tabbar v-model="active" active-color="#FD4A46">
        <van-tabbar-item @click="tabsTo(1)">
          <span>预约</span>
          <template #icon="props">
            <img
              v-if="props.active"
              src="../../assets/images/ph-11.png"
              alt=""
            />
            <img v-else src="../../assets/images/t-01.png" alt="" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item @click="tabsTo(2)">
          <span>申报</span>
          <template #icon="props">
            <img v-if="props.active" src="../../assets/images/sq1.png" alt="" />
            <img v-else src="../../assets/images/sq0.png" alt="" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item icon="search" @click="tabsTo(3)">
          <span>我的</span>
          <template #icon="props">
            <img v-if="props.active" src="../../assets/images/my.png" alt="" />
            <img v-else src="../../assets/images/t-02.png" alt="" />
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </van-tabbar>

    <div class="bg" v-if="bgshow">
      <div class="bgcontent">
        <div class="title">恭喜您</div>
        <div class="bimg">
          <img src="../../assets/images/success@2x.png" alt="" />
        </div>
        <div class="title2">预约提交成功</div>
        <div class="btn" @click="changeBg">关闭</div>
      </div>
    </div>
  </div>
</template>
<script src="http://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<script>
import wx from "weixin-js-sdk";
import mix1 from "@/mixins/page";
import { uiShowLoading, uiHideLoading, uiAlert, uiConfirm } from "@/utils/ui";
import {
  Field,
  Popup,
  Button,
  NumberKeyboard,
  Swipe,
  SwipeItem,
  Lazyload,
  Card,
  Tabbar,
  TabbarItem,
  List,
  Toast,
  Form,
  DatetimePicker,
  Uploader,
  NavBar,
  Checkbox,
  CellGroup,
} from "vant";
import { delayAsync } from "@/utils/common";
export default {
  mixins: [mix1],
  name: "declarIndex",
  components: {
    // MgPopup,
    Button,
    [Button.name]: Button,
    [Field.name]: Field,
    [Popup.name]: Popup,
    NumberKeyboard,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Lazyload.name]: Lazyload,
    [Card.name]: Card,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [List.name]: List,
    [Form.name]: Form,
    [DatetimePicker.name]: DatetimePicker,
    [Uploader.name]: Uploader,
    [NavBar.name]: NavBar,
    [Checkbox.name]: Checkbox,
  },
  data() {
    return {
      active: 1,
      formData: {
        applicantName: "",
        date: "",
        population: "",
        realname: "",
        phone: "",
        imgs: [],
      },
      infodata: {
        declarant: 0, //申报人 1:是
        staff: 0, //工作人员 1:是
        quota: 0, //配额数
        usedCount: 0, //已用数量
        usableCount: 0, //可用数量
      },
      currentDate: new Date(),
      showPicker: false,
      minDate: new Date(),
      maxDate: "",
      banner: {},
      // imgkeys:[],
      bgshow: false,
      redPhone: false,
      queryId: "",
      noCanUp: false, //是否可以上传文件
      ismai: true, //是否购买接驳车车票
      restrict: 1, //是否可以修改
    };
  },
  created() {
    this.getwxsdk();
    this.setmaxDate();
    this.getData();
    this.getBanner();
    this.getUserInfo();
    this.isLimit();
  },
  methods: {
    async isLimit() {
      let promise = await this.apiGet("yy.islimit");
      this.restrict = promise.obj.restrict;
    },
    async getwxsdk() {
      const promise = this.apiGet("getsdfkcfg", { url: window.location.href });
      let apiResult = null;
      try {
        apiResult = await promise;
      } catch (ex) {
        apiResult = null;
      }
      console.log("获取微信的配置", apiResult);
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
        appId: apiResult.obj.appid, // 必填，公众号的唯一标识
        timestamp: apiResult.obj.timestamp, // 必填，生成签名的时间戳
        nonceStr: apiResult.obj.noncestr, // 必填，生成签名的随机串
        signature: apiResult.obj.signature, // 必填，签名
        jsApiList: [""], // 必填，需要使用的JS接口列表
        openTagList: ["wx-open-launch-weapp"], // 可选，需要使用的开放标签列表
      });
    },

    changemai(e) {
      if (this.restrict == 1) {
        this.ismai = true;
      }
    },

    setmaxDate() {
      // 创建一个表示当前时间的新Date对象
      let currentDate = new Date();

      // 计算7天后的毫秒数
      let sevenDaysLaterMs = currentDate.getTime() + 7 * 24 * 60 * 60 * 1000;

      // 使用计算出的毫秒数创建一个新的Date对象
      let sevenDaysLater = new Date(sevenDaysLaterMs);

      // 将新的Date对象转换为默认的字符串格式（类似于 "Fri Jan 05 2024 12:00:00 GMT+0800 (China Standard Time)"）
      // let formattedSevenDaysLater = sevenDaysLater.toString();

      console.log("七天后的时间是: ", sevenDaysLater);
      this.maxDate = sevenDaysLater;
    },
    // 获取并且修改信息
    async getData() {
      const promise = this.apiGet("yy.state");
      let apiResult = null;
      try {
        apiResult = await promise;
      } catch (ex) {
        apiResult = null;
      }

      console.log("apiResult", apiResult);
      if (apiResult.obj.imgs) {
        console.log("存在数据赋值", apiResult.obj);
        this.formData = apiResult.obj;
        if (apiResult.obj.buyTicket == 1) {
          this.ismai = true;
        }
        if (apiResult.obj.buyTicket == 0) {
          this.ismai = false;
        }
      }

      this.queryId = this.$route.query.id;
      console.log("是否有id：", this.queryId);
      if (
        this.queryId != "" &&
        this.queryId != undefined &&
        this.queryId != null
      ) {
        console.log("进来了,有id");
      }

      console.log("getData:", this.formData);
    },
    // 正确的手机号
    okPhone() {
      const reg = /^1[3-9]\d{9}$/;

      console.log("当前判断的手机号:", this.formData.phone);

      let state = typeof this.formData.phone;
      console.log("当前类型:", state);

      let rog = reg.test(this.formData.phone);
      console.log("当前状态:", rog);

      if (!reg.test(this.formData.phone)) {
        console.log("手机号错");
        this.redPhone = true;
      }
      if (reg.test(this.formData.phone)) {
        console.log("手机号对");
        this.redPhone = false;
      }

      // return /^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(
      //   val
      // );
    },

    onClickLeft() {
      this.$router.go(-1);
    },

    async getUserInfo() {
      const promise = this.apiGet("my.userInfo");
      let apiResult = null;
      try {
        apiResult = await promise;
      } catch (ex) {
        apiResult = null;
      }

      if (this.isEmpty(apiResult)) {
        return;
      }

      this.infodata = apiResult.obj;
      console.log("this.infodata=>", this.infodata);
    },
    // 获取banner
    async getBanner() {
      let data = {
        type: 5,
      };
      uiShowLoading();
      const promise = this.apiGet("homepage.banner", data);
      let apiResult = null;

      try {
        apiResult = await promise;
      } catch (ex) {
        console.log("ex：", ex);
        apiResult = null;
      }

      if (this.isEmpty(apiResult)) {
        return;
      }
      console.log("getBanner:", apiResult.obj);

      this.banner = apiResult.obj;
      uiHideLoading();
    },
    tabsTo(type) {
      if (type == 1) {
        this.$router.push("/");
      } else if (type == 2) {
        this.$router.push("/declaration/index");
      } else {
        this.$router.push("/my/index");
      }
    },
    async onSubmit() {
      console.log(this.formData);
      const reg = /^1[3-9]\d{9}$/;
      let rew = reg.test(this.formData.phone);
      console.log("rew", rew);
      if (!rew) {
        console.log("this.formData.phone:", this.formData.phone);
        this.redPhone = true;
        return;
      }
      if (rew) {
        this.redPhone = false;
      }
      let data = {};
      data.applicantName = this.formData.applicantName;
      data.date = this.formData.date;
      data.realname = this.formData.realname;
      data.phone = this.formData.phone;
      data.population = this.formData.population;
      data.imgs = JSON.stringify(this.formData.imgs);
      if (this.ismai) {
        data.buyTicket = 1;
        console.log("wx.config", wx.config);
      }
      if (!this.ismai) {
        data.buyTicket = 0;
      }
      if (
        this.queryId == "" ||
        this.queryId == undefined ||
        this.queryId == null
      ) {
        console.log("无id情况，首次提交");
        const promise = this.apiPost("yy.postForm", data);
        let apiResult = null;
        try {
          apiResult = await promise;
        } catch (ex) {
          apiResult = null;
        }
        console.log(apiResult);
        if (apiResult.errno == 0) {
          // let ismai = this.ismai

          if (this.ismai) {
            if (wx && wx.miniProgram) {
              // alert('wx环境，鉴权',wx.config)
              wx.miniProgram.navigateTo({
                url: "/shop/product?id=71",
              });
            }
            this.bgshow = true;
          } else {
            this.bgshow = true;
          }
        } else {
          Toast("提交不成功");
        }
        if (this.hasException(apiResult)) {
          return;
        }
        console.log(promise);
      } else {
        console.log("有id，put");
        let id = this.$route.query.id;
        const promise = this.apiPut("yy.state.put", { id: id }, data);
        let apiResult = null;
        try {
          apiResult = await promise;
        } catch (ex) {
          apiResult = null;
        }
        console.log(apiResult);
        if (this.hasException(apiResult)) {
          return;
        }
        if (apiResult.error == 0) {
          if (this.ismai) {
            console.log("有id且买接驳车车票");
            if (wx && wx.miniProgram) {
              // alert('wx环境，鉴权', wx.config)
              wx.miniProgram.navigateTo({
                url: "/shop/product?id=71",
              });
            }
            this.bgshow = true;
          } else {
            this.bgshow = true;
          }
        } else {
          Toast("提交不成功");
        }
        // this.bgshow = true;
        console.log(promise);
      }
    },

    onConfirm(time) {
      console.log(time);

      let s = new Date(time);
      const startDate =
        s.getFullYear() +
        "-" +
        this.p(s.getMonth() + 1) +
        "-" +
        this.p(s.getDate());
      console.log(startDate); //2023-06-01

      this.formData.date = startDate;
      this.showPicker = false;
    },

    p(m) {
      return m < 9 ? "0" + m : m;
    },

    async beforeRead(file) {
      let data = file.content;
      console.log("beforeRead-file", file);
      console.log("data", data);
    },

    afterDelete(x) {
      console.log("x", x);
      let index = x;
      this.formData.imgs.splice(index, 1);
      console.log("删除后的formData.imgs:", this.formData.imgs);
      if (this.formData.imgs.length < 3) {
        this.noCanUp = false;
      }
    },

    afterRead(...args) {
      console.log("afterRead-args", args);
      let size = 2097152;
      if (args[0].size > size) {
        this.uiAlert("上传图片不能大于10MB");
        return;
      }
      this.upData(args[0].content);
      // return true
    },

    async compressImg(base64, multiple) {
      // 第一个参数就是需要加密的base65，
      // 第二个是压缩系数 0-1，
      // 第三个压缩后的回调 用来获取处理后的 base64
      if (!base64) {
        return;
      }
      const _this = this;
      const length = base64.length / 1024;
      // 压缩方法
      let newImage = new Image();
      let quality = 0.9; // 压缩系数0-1之间
      newImage.src = base64;
      newImage.setAttribute("crossOrigin", "Anonymous"); // url为外域时需要
      let imgWidth, imgHeight;
      let w = undefined;
      newImage.onload = function () {
        // 这里面的 this 指向 newImage
        // 通过改变图片宽高来实现压缩
        w = this.width * multiple;
        imgWidth = this.width;
        imgHeight = this.height;
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        if (Math.max(imgWidth, imgHeight) > w) {
          if (imgWidth > imgHeight) {
            canvas.width = w;
            // 等比例缩小
            canvas.height = w * (imgHeight / imgWidth);
          } else {
            canvas.height = w;
            // 等比例缩小
            canvas.width = w * (imgWidth / imgHeight);
          }
        } else {
          canvas.width = imgWidth;
          canvas.height = imgHeight;
          // quality 设置转换为base64编码后图片的质量，取值范围为0-1  没什么压缩效果
          // 还是得通过设置 canvas 的宽高来压缩
          quality = 0.8;
        }
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(this, 0, 0, canvas.width, canvas.height); //  // 这里面的 this 指向 newImage
        let smallBase64 = canvas.toDataURL("image/jpeg", quality); // 压缩语句
        // 如想确保图片压缩到自己想要的尺寸,如要求在50-150kb之间，请加以下语句，quality初始值根据情况自定
        // while (smallBase64.length / 1024 > 150) {
        // quality -= 0.01;
        // smallBase64 = canvas.toDataURL("image/jpeg", quality);
        // }
        // 防止最后一次压缩低于最低尺寸，只要quality递减合理，无需考虑
        // while (smallBase64.length / 1024 < 50) {
        // quality += 0.001;
        // smallBase64 = canvas.toDataURL("image/jpeg", quality);
        // }

        // 必须通过回调函数返回，否则无法及时拿到该值，回调函数异步执行
        console.log(`压缩前：${length}KB`);
        console.log(`压缩后：${smallBase64.length / 1024} KB`);
        console.log("smallBase64", smallBase64);
        _this.upData(smallBase64);
      };
    },

    async upData(smallBase64) {
      console.log("smallBase64:", smallBase64);
      let content = smallBase64.split(",").splice(1, 1);
      console.log("处理好的base64:", content);
      if (this.isEmpty(content[0])) {
        console.log("base64是空，进入这个提示");
        Toast("上传图片失败");
        return;
      }
      uiShowLoading();
      await delayAsync(500);
      const promise = this.apiPost("image.save", { base64: content[0] });
      let apiResult = null;
      try {
        apiResult = await promise;
      } catch (ex) {
        apiResult = null;
      }
      uiHideLoading();
      if (this.hasException(apiResult)) {
        return;
      }
      console.log("图片上传后的返回结果:", apiResult);

      this.formData.imgs.push(apiResult.obj.resourceKey);
      console.log("改动formData.imgs:", this.formData.imgs);

      if (this.formData.imgs.length == 3) {
        this.noCanUp = true;
      }
    },

    changeBg() {
      this.bgshow = false;
      this.$router.push("/declare/declareOk");
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  padding-bottom: 100px;

  .pgt {
    padding: 0px 20px 36px;
    .xxxxx {
      height: 100px;
      background-color: #fff;
    }
  }

  .pa-top {
    width: 100%;
    height: 314px;
    padding-top: 20px;
    border-radius: 15px;
    background: #edf0f4;
  }

  .info-box {
    margin-top: 16px;
    background-color: #fff;
    .title {
      text-align: center;
      font-weight: bold;
      font-size: 18px;
      color: #38251e;
      line-height: 31px;
      padding-top: 27px;
      padding-bottom: 29px;
    }
    .twonum {
      margin: 0 auto;
      border-bottom: 10px;
      // border: 1px solid red;
      width: 510px;
      height: 60px;
      display: flex;
      justify-content: space-between;
      .num1,
      .num2 {
        width: 226px;
        height: 60px;
        background-color: #f5f5f5;
        border-radius: 30px 30px 30px 30px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .num1-txt,
      .num2-txt {
        // width: 162px;
        height: 40px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #030303;
        line-height: 40px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
    }
    .flex-box {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      margin-right: 30px;
      .label {
        display: block;
        width: 200px;
        text-align: center;
        font-size: 15px;
        color: #000000;
      }
    }
    .gou {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      margin-bottom: 20px;
      .label {
        display: block;
        width: 160px;
        text-align: center;
        font-size: 15px;
        color: #000000;
        // margin-bottom: 20px;
      }
    }
    .license {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      margin-bottom: 20px;
      .label {
        display: block;
        width: 160px;
        text-align: center;
        font-size: 15px;
        color: #000000;
        margin-bottom: 20px;
      }
      .tip {
        width: 710px;
        .tip-txt {
          display: inline-block;
          width: 160px;
          text-align: center;
          // margin-left:13px;
          color: #c8c8c8;
          font-size: 11px;
        }
      }

      .img-list {
        width: 750px;
        margin-top: 20px;
        display: flex;
        .img-box {
          border: 1px solid #ccc;
          width: 140px;
          height: 140px;
          margin-left: 20px;
          display: inline-block;
          position: relative;
          img {
            width: 140px;
            height: 140px;
          }
          .img-box-d {
            // border: 1px solid red;
            width: 30px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            background-color: rgba(0, 0, 0, 0.3);
            position: absolute;
            top: 0;
            right: 0;
            color: #fff;
            z-index: 99998;
          }
        }
      }
    }
    .up-img-box {
      margin-left: 26px;
      width: 454px;
      height: 140px;
      display: flex;
      .up-img {
        margin-left: 17px;
      }
    }
    .bottom-tip {
      margin: 0 auto;
      margin-top: 30px;
      width: 476px;
      height: 40px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 11px;
      color: #fd4a46;
      line-height: 0px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }
  }
  .empt {
    height: 100px;
  }

  .bg {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(70, 70, 70, 0.3);
    z-index: 99998;
    .bgcontent {
      width: 632px;
      height: 613px;
      background: #ffffff;
      border-radius: 15px 15px 15px 15px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      z-index: 99999;
      .title {
        width: 632px;
        height: 46px;
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 16px;
        color: #000000;
        line-height: 46px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        text-align: center;
        margin-top: 66px;
      }
      .bimg {
        width: 96px;
        height: 96px;
        margin-top: 45px;
        img {
          display: block;
          width: 96px;
          height: 96px;
        }
      }
      .title2 {
        width: 632px;
        height: 54px;
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 19px;
        color: #fd4a46;
        line-height: 54px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
      .btn {
        width: 441px;
        height: 88px;
        line-height: 88px;
        background: #fd4a46;
        border-radius: 44px 44px 44px 44px;
        text-align: center;
        color: #ffffff;
        font-size: 16px;
      }
    }
  }

  .flex-box-tip {
    margin-left: 180px;
    font-size: 12px;
    color: #ff0b0b;
  }

  borda {
    border: 1px solid #ccc !important;
  }
}
</style>